import { apiSlice } from "../../app/apiSlice";
import { withDefaultMeta } from "../../util/withDefaultMeta";

export const plansApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    const query = withDefaultMeta(builder.query);
    const mutation = withDefaultMeta(builder.mutation);

    return {
      // ✅ Get all plans
      getPlans: query({
        query: () => "/plans",
        providesTags: (result) =>
          result
            ? [
                ...result.map(({ _id }) => ({ type: "Plan", id: _id })),
                { type: "Plan", id: "LIST" },
              ]
            : [{ type: "Plan", id: "LIST" }],
      }),

      // ✅ Get single plan
      getPlanById: query({
        query: (id) => `/plans/${id}`,
        providesTags: (result, error, id) => [{ type: "Plan", id }],
      }),

      // ✅ Create new plan
      createPlan: mutation({
        query: (newPlan) => ({
          url: "/plans",
          method: "POST",
          body: newPlan,
        }),
        invalidatesTags: [{ type: "Plan", id: "LIST" }],
      }),

      // ✅ Update existing plan
      updatePlan: mutation({
        query: ({ id, ...data }) => ({
          url: `/plans/${id}`,
          method: "PUT",
          body: data,
        }),
        invalidatesTags: (result, error, { id }) => [
          { type: "Plan", id },
          { type: "Plan", id: "LIST" },
        ],
      }),

      // ✅ Delete a plan
      deletePlan: mutation({
        query: (id) => ({
          url: `/plans/${id}`,
          method: "DELETE",
        }),
        invalidatesTags: (result, error, id) => [
          { type: "Plan", id },
          { type: "Plan", id: "LIST" },
        ],
      }),
    };
  },
});

export const {
  useGetPlansQuery,
  useGetPlanByIdQuery,
  useCreatePlanMutation,
  useUpdatePlanMutation,
  useDeletePlanMutation,
} = plansApiSlice;
